export default __webpack_public_path__ + "static/media/diamond-carat-4@2x.1907f08e.jpg";